export default __webpack_public_path__ + "static/media/pdf_icon.e328b1cf.svg";